import React, { useEffect, useState } from 'react'
import EditHighlightStyles from './EditInvestHighlight.module.css'
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
import { Button } from '@mui/material';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux'
import { setNotificationCount } from '../../state/GlobalState';

const EditInvestHighlight = () => {
    const name = useSelector((state) => state.globalData.name);
    const count = useSelector((state) => state.globalData.notificationCount);
    const dispatch = useDispatch()

    const location = useLocation()
    const data = location.state

    const navigate = useNavigate()
    const inputRef = React.useRef();

    const [formData, setFormData] = useState({
        investmentHeader: '',
        investmentDetails: '',
        file: null,
    });


    const [source, setSource] = React.useState();
    const [fileName, setFileName] = React.useState('');
    const [imageSelect, setImageSelect] = useState(false);


    useEffect(() => {
        if (data.logo) {
            const fetchImage = async () => {
                try {
                    const imageResponse = await axios.get(
                        `${process.env.REACT_APP_COSMOSADMIN}/investmentHighlights/file/${data.logo}`
                    );

                    setSource(imageResponse.data);
                } catch (error) {
                    console.error(error);
                }
            };

            fetchImage();
        }
    }, [data.logo]);


    useEffect(() => {
        if (data) {
            setFormData({
                investmentHeader: data.highlights.investmentHeader || '',
                investmentDetails: data.highlights.investmentDetails || '',
                file: null, // reset file when data changes
            });
        }
    }, [data]);



    const handleFileChange = (event) => {
        const file = event.target.files[0];
        setFileName(file.name)
        const url = URL.createObjectURL(file);
        setSource(url);
        setImageSelect(true)
        setFormData({ ...formData, file: file });
    };

    const handleChoose = (event) => {
        inputRef.current.click();
    };

    const discardImage = (event) => {
        setSource(null)
        setFileName('')
        setFormData((prevData) => ({
            ...prevData,
            file: null,
        }));
        inputRef.current.value = ""
        setImageSelect(false)
    }

    const handleSubmit = async (event) => {
        event.preventDefault()

        const textData = {
            investmentHeader: formData.investmentHeader,
            investmentDetails: formData.investmentDetails,
        };

        try {
            if (
                textData.investmentHeader !== data.highlights.investmentHeader ||
                textData.investmentDetails !== data.highlights.investmentDetails
            ) {
                const highlightResponse = await axios.post(
                    `${process.env.REACT_APP_COSMOSADMIN}/investmentHighlights/updateInvestmentHighlights/${data.highlights.investmentId}`,
                    textData,
                    {
                        headers: {
                            "Content-Type": "application/json",
                        },
                    }
                )
                dispatch(setNotificationCount({
                    count: count + 1,
                }))


                alert('Highlight Updated.');
                navigate('/investment');
            }
        } catch (error) {
            console.error(error)
        }

        if (formData.file) {
            const formDataObj = new FormData();
            formDataObj.append('file', formData.file);

            try {
                const imageResponse = await axios.post(
                    `${process.env.REACT_APP_COSMOSADMIN}/investmentHighlights/uploadLogoById/${data.logoId}`,
                    formDataObj,
                    {
                        headers: {
                            "Content-Type": "image/jpeg"

                        },
                    });
                alert('Highlight Updated.');
                navigate('/investment');
                const url = URL.createObjectURL(formData.file);
                setSource(url)
            } catch (error) {
                console.error(error);
            }
        }

        discardImage();
    };



    return (
        <div className={EditHighlightStyles.editHighlightMain}>
            <div className={EditHighlightStyles.editHighlightContent}>
                <form action="" className={EditHighlightStyles.editHighlightForm} onSubmit={handleSubmit} encType='multipart/form-data'>

                    <label className={EditHighlightStyles.editHighlightFormLabel}>Title</label>
                    <input className={EditHighlightStyles.editHighlightFormText}
                        type="text"
                        value={formData.investmentHeader}
                        name='investmentHeader'
                        onChange={(event) => setFormData({ ...formData, investmentHeader: event.target.value })}
                    />

                    <label className={EditHighlightStyles.editHighlightFormLabel}>Description</label>
                    <textarea className={EditHighlightStyles.editHighlightFormDesc}
                        type="text"
                        value={formData.investmentDetails}
                        name='investmentDetails'
                        onChange={(event) => setFormData({ ...formData, investmentDetails: event.target.value })}
                    />

                    <label className={EditHighlightStyles.editHighlightFormLabel}>Upload</label>
                    <div className={EditHighlightStyles.ImgInput}>
                        <input
                            ref={inputRef}
                            className={EditHighlightStyles.ImgInput_input}
                            type="file"
                            onChange={handleFileChange}
                        />
                        {!source && <button type='button' onClick={handleChoose}>Browse</button>}
                        {source && (
                            <img
                                className={EditHighlightStyles.ImgInput_img}
                                width="100%"
                                src={`${process.env.REACT_APP_COSMOSADMIN}/investmentHighlights/file/${data.logo}`}
                                alt='uploadedimage'
                            />
                        )}
                    </div>
                    <div className={EditHighlightStyles.ImgInput_footer}>
                        {imageSelect ?
                            <div style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center' }}>
                                {fileName}
                            </div> :
                            ''}
                        <DeleteForeverOutlinedIcon onClick={discardImage} sx={{ cursor: 'pointer' }} />
                    </div>
                    <Button variant='contained' type='submit' className={EditHighlightStyles.saveChanges}>Save changes</Button>
                </form>
            </div>
        </div>
    )
}

export default EditInvestHighlight